import PropTypes from 'prop-types';
import React from 'react';

import Confirm from 'common/components/Confirm';

import styles from './RideShareNotificationModal.css';

const RideShareNotificationModal = ({onAccept, serviceName}) => {
  const message = (
    <div className={styles.message}>
      <div>
        {serviceName} is a ridesharing service. With extra riders, your trip
        may take a little longer, but you will have access to your pickup
        and drop-off predictions along the way.
      </div>
    </div>
  );

  return (
    <Confirm
      confirmButtonText="Okay"
      confirmButtonDataId="rideshare-confirm-button"
      title="On-Demand Ridesharing"
      messageDataId="rideshare-message"
      message={message}
      modalDataId={'rideshare-modal-container'}
      hideCancel
      onConfirm={onAccept}
      open
    />
  );
};

RideShareNotificationModal.propTypes = {
  onAccept: PropTypes.func,
  serviceName: PropTypes.string,
};

export default RideShareNotificationModal;



// WEBPACK FOOTER //
// ./src/ondemand/components/RideShareNotificationModal/RideShareNotificationModal.js